module.exports = __webpack_public_path__ + "img/noEdit.59126eb7.svg";